// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================================================
   Global dark-theme overrides.
   Scoped under [data-theme="dark"] so light mode is never affected.
   Covers generic elements + third-party widgets (react-bootstrap, react-select,
   react-datepicker, scrollbars). Ant Design and MUI are themed via providers.
   ========================================================================= */

/* Smooth transition for theme switch across common surfaces */
[data-theme] .App,
[data-theme] .main-content2 {
  transition: background-color 0.25s ease, color 0.25s ease;
}

/* ----- App shell ----- */
[data-theme="dark"] .App {
  background-color: var(--app-bg);
  color: var(--text);
}

[data-theme="dark"] .main-content2 {
  background-color: var(--app-bg);
  color: var(--text);
}

/* ----- Generic form controls ----- */
[data-theme="dark"] input:not([type="checkbox"]):not([type="radio"]):not([type="range"]):not([type="color"]),
[data-theme="dark"] textarea,
[data-theme="dark"] select {
  background-color: var(--surface);
  color: var(--text);
  border-color: var(--border);
}

[data-theme="dark"] input::placeholder,
[data-theme="dark"] textarea::placeholder {
  color: var(--text-subtle);
}

/* ----- Bootstrap / react-bootstrap utility + component classes ----- */
[data-theme="dark"] .bg-white,
[data-theme="dark"] .bg-light {
  background-color: var(--surface) !important;
  color: var(--text);
}

[data-theme="dark"] .text-dark {
  color: var(--text) !important;
}

[data-theme="dark"] .text-muted,
[data-theme="dark"] .text-secondary {
  color: var(--text-muted) !important;
}

[data-theme="dark"] .card,
[data-theme="dark"] .modal-content,
[data-theme="dark"] .list-group-item,
[data-theme="dark"] .dropdown-menu,
[data-theme="dark"] .popover,
[data-theme="dark"] .accordion-item,
[data-theme="dark"] .offcanvas {
  background-color: var(--surface);
  color: var(--text);
  border-color: var(--border);
}

[data-theme="dark"] .card-header,
[data-theme="dark"] .card-footer,
[data-theme="dark"] .modal-header,
[data-theme="dark"] .modal-footer {
  background-color: var(--surface-2);
  color: var(--text);
  border-color: var(--border);
}

[data-theme="dark"] .dropdown-item {
  color: var(--text);
}
[data-theme="dark"] .dropdown-item:hover,
[data-theme="dark"] .dropdown-item:focus {
  background-color: var(--surface-hover);
  color: var(--text);
}

[data-theme="dark"] .form-control,
[data-theme="dark"] .form-select {
  background-color: var(--surface);
  color: var(--text);
  border-color: var(--border);
}
[data-theme="dark"] .form-control:focus,
[data-theme="dark"] .form-select:focus {
  background-color: var(--surface);
  color: var(--text);
  border-color: var(--primary);
  box-shadow: 0 0 0 0.2rem var(--primary-soft);
}
[data-theme="dark"] .form-control::placeholder {
  color: var(--text-subtle);
}

[data-theme="dark"] .table {
  color: var(--text);
  --bs-table-bg: transparent;
  --bs-table-color: var(--text);
  --bs-table-border-color: var(--border);
  --bs-table-striped-color: var(--text);
  --bs-table-striped-bg: var(--surface-2);
  --bs-table-hover-color: var(--text);
  --bs-table-hover-bg: var(--surface-hover);
}
[data-theme="dark"] .table > :not(caption) > * > * {
  border-color: var(--border);
}

[data-theme="dark"] .modal-backdrop {
  background-color: #000;
}

[data-theme="dark"] .close,
[data-theme="dark"] .btn-close {
  filter: invert(1) grayscale(1) brightness(1.4);
}

/* ----- react-select (targets the classNamePrefix "__" convention used in
   this app: react-select__, select__, failed-idoc-select__, etc.) ----- */
[data-theme="dark"] [class*="__control"] {
  background-color: var(--surface);
  border-color: var(--border);
  color: var(--text);
}
[data-theme="dark"] [class*="__menu"] {
  background-color: var(--surface);
  color: var(--text);
  border: 1px solid var(--border);
}
[data-theme="dark"] [class*="__option"] {
  background-color: var(--surface);
  color: var(--text);
}
[data-theme="dark"] [class*="__option"]:hover,
[data-theme="dark"] [class*="__option--is-focused"] {
  background-color: var(--surface-hover) !important;
  color: var(--text);
}
[data-theme="dark"] [class*="__single-value"],
[data-theme="dark"] [class*="__input"],
[data-theme="dark"] [class*="__placeholder"] {
  color: var(--text);
}
[data-theme="dark"] [class*="__multi-value"] {
  background-color: var(--surface-3);
}
[data-theme="dark"] [class*="__multi-value__label"] {
  color: var(--text);
}

/* ----- react-datepicker ----- */
[data-theme="dark"] .react-datepicker {
  background-color: var(--surface);
  border-color: var(--border);
  color: var(--text);
}
[data-theme="dark"] .react-datepicker__header {
  background-color: var(--surface-2);
  border-color: var(--border);
}
[data-theme="dark"] .react-datepicker__current-month,
[data-theme="dark"] .react-datepicker-time__header,
[data-theme="dark"] .react-datepicker__day-name,
[data-theme="dark"] .react-datepicker__day,
[data-theme="dark"] .react-datepicker__time-name {
  color: var(--text);
}
[data-theme="dark"] .react-datepicker__day:hover,
[data-theme="dark"] .react-datepicker__month-text:hover {
  background-color: var(--surface-hover);
}
[data-theme="dark"] .react-datepicker__day--selected,
[data-theme="dark"] .react-datepicker__day--keyboard-selected {
  background-color: var(--primary);
  color: #fff;
}
[data-theme="dark"] .react-datepicker__time-container,
[data-theme="dark"] .react-datepicker__time,
[data-theme="dark"] .react-datepicker__time-box {
  background-color: var(--surface);
  color: var(--text);
}
[data-theme="dark"] .react-datepicker__time-list-item:hover {
  background-color: var(--surface-hover) !important;
}

/* ----- Scrollbars ----- */
[data-theme="dark"] ::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
[data-theme="dark"] ::-webkit-scrollbar-track {
  background: var(--scrollbar-track);
}
[data-theme="dark"] ::-webkit-scrollbar-thumb {
  background: var(--scrollbar-thumb);
  border-radius: 6px;
}
[data-theme="dark"] * {
  scrollbar-color: var(--scrollbar-thumb) transparent;
}

/* ----- Theme toggle button (navbar) ----- */
.theme-toggle-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 42px;
  padding: 0 14px;
  border-radius: 10px;
  border: 1px solid var(--border);
  background: var(--surface-2);
  color: var(--text-muted);
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease, transform 0.12s ease;
}
.theme-toggle-label {
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
}
.theme-toggle-btn:hover {
  background: var(--surface-hover);
  border-color: var(--border-strong);
  color: var(--text);
}
.theme-toggle-btn:active {
  transform: scale(0.94);
}
.theme-toggle-btn:focus-visible {
  outline: 2px solid var(--primary);
  outline-offset: 2px;
}

@media (max-width: 768px) {
  .theme-toggle-btn {
    width: 40px;
    height: 40px;
    padding: 0;
  }
}

/* ----- Tailwind utility classes (used across data/report/self-monitoring
   pages). These have fixed light colors, so remap them in dark mode. ----- */
[data-theme="dark"] .bg-slate-50,
[data-theme="dark"] .bg-slate-100,
[data-theme="dark"] .bg-gray-50,
[data-theme="dark"] .bg-gray-100,
[data-theme="dark"] .bg-neutral-50,
[data-theme="dark"] .bg-neutral-100 {
  background-color: var(--surface-2) !important;
}

[data-theme="dark"] .bg-slate-200,
[data-theme="dark"] .bg-gray-200 {
  background-color: var(--surface-3) !important;
}

/* Loading / dimming overlays that use white + opacity */
[data-theme="dark"] .bg-white.bg-opacity-75,
[data-theme="dark"] .bg-white.bg-opacity-80,
[data-theme="dark"] .bg-white.bg-opacity-90 {
  background-color: rgba(15, 23, 42, 0.75) !important;
}

/* Text colors */
[data-theme="dark"] .text-black,
[data-theme="dark"] .text-slate-900,
[data-theme="dark"] .text-slate-800,
[data-theme="dark"] .text-slate-700,
[data-theme="dark"] .text-gray-900,
[data-theme="dark"] .text-gray-800,
[data-theme="dark"] .text-gray-700,
[data-theme="dark"] .text-neutral-800,
[data-theme="dark"] .text-neutral-700 {
  color: var(--text) !important;
}

[data-theme="dark"] .text-slate-600,
[data-theme="dark"] .text-slate-500,
[data-theme="dark"] .text-slate-400,
[data-theme="dark"] .text-gray-600,
[data-theme="dark"] .text-gray-500,
[data-theme="dark"] .text-gray-400,
[data-theme="dark"] .text-neutral-600,
[data-theme="dark"] .text-neutral-500 {
  color: var(--text-muted) !important;
}

/* Borders */
[data-theme="dark"] .border-slate-100,
[data-theme="dark"] .border-slate-200,
[data-theme="dark"] .border-slate-300,
[data-theme="dark"] .border-gray-100,
[data-theme="dark"] .border-gray-200,
[data-theme="dark"] .border-gray-300,
[data-theme="dark"] .border-neutral-200,
[data-theme="dark"] .border-neutral-300 {
  border-color: var(--border) !important;
}

/* Divide utilities (borders between children) */
[data-theme="dark"] .divide-slate-100 > :not([hidden]) ~ :not([hidden]),
[data-theme="dark"] .divide-slate-200 > :not([hidden]) ~ :not([hidden]),
[data-theme="dark"] .divide-gray-100 > :not([hidden]) ~ :not([hidden]),
[data-theme="dark"] .divide-gray-200 > :not([hidden]) ~ :not([hidden]) {
  border-color: var(--border) !important;
}

/* Hover backgrounds (table rows, list items) */
[data-theme="dark"] .hover\\:bg-slate-50:hover,
[data-theme="dark"] .hover\\:bg-slate-100:hover,
[data-theme="dark"] .hover\\:bg-gray-50:hover,
[data-theme="dark"] .hover\\:bg-gray-100:hover {
  background-color: var(--surface-hover) !important;
}

/* Soft accent tints used for badges / alerts */
[data-theme="dark"] .bg-red-50 {
  background-color: rgba(239, 68, 68, 0.12) !important;
}
[data-theme="dark"] .border-red-200 {
  border-color: rgba(239, 68, 68, 0.35) !important;
}
[data-theme="dark"] .text-red-800,
[data-theme="dark"] .text-red-700,
[data-theme="dark"] .text-red-600 {
  color: #f87171 !important;
}
[data-theme="dark"] .bg-blue-50,
[data-theme="dark"] .bg-indigo-50 {
  background-color: rgba(59, 130, 246, 0.14) !important;
}
[data-theme="dark"] .bg-green-50,
[data-theme="dark"] .bg-emerald-50 {
  background-color: rgba(16, 185, 129, 0.14) !important;
}
[data-theme="dark"] .bg-yellow-50,
[data-theme="dark"] .bg-amber-50 {
  background-color: rgba(245, 158, 11, 0.14) !important;
}
`, "",{"version":3,"sources":["webpack://./src/theme.css"],"names":[],"mappings":"AAAA;;;;;8EAK8E;;AAE9E,8DAA8D;AAC9D;;EAEE,yDAAyD;AAC3D;;AAEA,0BAA0B;AAC1B;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA,sCAAsC;AACtC;;;EAGE,gCAAgC;EAChC,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,wEAAwE;AACxE;;EAEE,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;;;;;;;EAOE,gCAAgC;EAChC,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;;;;EAIE,kCAAkC;EAClC,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;AACA;;EAEE,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;;EAEE,gCAAgC;EAChC,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;;EAEE,gCAAgC;EAChC,kBAAkB;EAClB,4BAA4B;EAC5B,4CAA4C;AAC9C;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,6BAA6B;EAC7B,sCAAsC;EACtC,qCAAqC;EACrC,uCAAuC;EACvC,mCAAmC;EACnC,yCAAyC;AAC3C;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,8CAA8C;AAChD;;AAEA;0EAC0E;AAC1E;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,+BAA+B;AACjC;AACA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;AACA;;EAEE,iDAAiD;EACjD,kBAAkB;AACpB;AACA;;;EAGE,kBAAkB;AACpB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;AACA;;;;;EAKE,kBAAkB;AACpB;AACA;;EAEE,sCAAsC;AACxC;AACA;;EAEE,gCAAgC;EAChC,WAAW;AACb;AACA;;;EAGE,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,iDAAiD;AACnD;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;AACA;EACE,mDAAmD;AACrD;;AAEA,6CAA6C;AAC7C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;EAC5B,wBAAwB;EACxB,eAAe;EACf,+FAA+F;AACjG;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;AACF;;AAEA;6EAC6E;AAC7E;;;;;;EAME,6CAA6C;AAC/C;;AAEA;;EAEE,6CAA6C;AAC/C;;AAEA,wDAAwD;AACxD;;;EAGE,mDAAmD;AACrD;;AAEA,gBAAgB;AAChB;;;;;;;;;EASE,6BAA6B;AAC/B;;AAEA;;;;;;;;EAQE,mCAAmC;AACrC;;AAEA,YAAY;AACZ;;;;;;;;EAQE,sCAAsC;AACxC;;AAEA,gDAAgD;AAChD;;;;EAIE,sCAAsC;AACxC;;AAEA,+CAA+C;AAC/C;;;;EAIE,iDAAiD;AACnD;;AAEA,+CAA+C;AAC/C;EACE,oDAAoD;AACtD;AACA;EACE,gDAAgD;AAClD;AACA;;;EAGE,yBAAyB;AAC3B;AACA;;EAEE,qDAAqD;AACvD;AACA;;EAEE,qDAAqD;AACvD;AACA;;EAEE,qDAAqD;AACvD","sourcesContent":["/* =========================================================================\n   Global dark-theme overrides.\n   Scoped under [data-theme=\"dark\"] so light mode is never affected.\n   Covers generic elements + third-party widgets (react-bootstrap, react-select,\n   react-datepicker, scrollbars). Ant Design and MUI are themed via providers.\n   ========================================================================= */\n\n/* Smooth transition for theme switch across common surfaces */\n[data-theme] .App,\n[data-theme] .main-content2 {\n  transition: background-color 0.25s ease, color 0.25s ease;\n}\n\n/* ----- App shell ----- */\n[data-theme=\"dark\"] .App {\n  background-color: var(--app-bg);\n  color: var(--text);\n}\n\n[data-theme=\"dark\"] .main-content2 {\n  background-color: var(--app-bg);\n  color: var(--text);\n}\n\n/* ----- Generic form controls ----- */\n[data-theme=\"dark\"] input:not([type=\"checkbox\"]):not([type=\"radio\"]):not([type=\"range\"]):not([type=\"color\"]),\n[data-theme=\"dark\"] textarea,\n[data-theme=\"dark\"] select {\n  background-color: var(--surface);\n  color: var(--text);\n  border-color: var(--border);\n}\n\n[data-theme=\"dark\"] input::placeholder,\n[data-theme=\"dark\"] textarea::placeholder {\n  color: var(--text-subtle);\n}\n\n/* ----- Bootstrap / react-bootstrap utility + component classes ----- */\n[data-theme=\"dark\"] .bg-white,\n[data-theme=\"dark\"] .bg-light {\n  background-color: var(--surface) !important;\n  color: var(--text);\n}\n\n[data-theme=\"dark\"] .text-dark {\n  color: var(--text) !important;\n}\n\n[data-theme=\"dark\"] .text-muted,\n[data-theme=\"dark\"] .text-secondary {\n  color: var(--text-muted) !important;\n}\n\n[data-theme=\"dark\"] .card,\n[data-theme=\"dark\"] .modal-content,\n[data-theme=\"dark\"] .list-group-item,\n[data-theme=\"dark\"] .dropdown-menu,\n[data-theme=\"dark\"] .popover,\n[data-theme=\"dark\"] .accordion-item,\n[data-theme=\"dark\"] .offcanvas {\n  background-color: var(--surface);\n  color: var(--text);\n  border-color: var(--border);\n}\n\n[data-theme=\"dark\"] .card-header,\n[data-theme=\"dark\"] .card-footer,\n[data-theme=\"dark\"] .modal-header,\n[data-theme=\"dark\"] .modal-footer {\n  background-color: var(--surface-2);\n  color: var(--text);\n  border-color: var(--border);\n}\n\n[data-theme=\"dark\"] .dropdown-item {\n  color: var(--text);\n}\n[data-theme=\"dark\"] .dropdown-item:hover,\n[data-theme=\"dark\"] .dropdown-item:focus {\n  background-color: var(--surface-hover);\n  color: var(--text);\n}\n\n[data-theme=\"dark\"] .form-control,\n[data-theme=\"dark\"] .form-select {\n  background-color: var(--surface);\n  color: var(--text);\n  border-color: var(--border);\n}\n[data-theme=\"dark\"] .form-control:focus,\n[data-theme=\"dark\"] .form-select:focus {\n  background-color: var(--surface);\n  color: var(--text);\n  border-color: var(--primary);\n  box-shadow: 0 0 0 0.2rem var(--primary-soft);\n}\n[data-theme=\"dark\"] .form-control::placeholder {\n  color: var(--text-subtle);\n}\n\n[data-theme=\"dark\"] .table {\n  color: var(--text);\n  --bs-table-bg: transparent;\n  --bs-table-color: var(--text);\n  --bs-table-border-color: var(--border);\n  --bs-table-striped-color: var(--text);\n  --bs-table-striped-bg: var(--surface-2);\n  --bs-table-hover-color: var(--text);\n  --bs-table-hover-bg: var(--surface-hover);\n}\n[data-theme=\"dark\"] .table > :not(caption) > * > * {\n  border-color: var(--border);\n}\n\n[data-theme=\"dark\"] .modal-backdrop {\n  background-color: #000;\n}\n\n[data-theme=\"dark\"] .close,\n[data-theme=\"dark\"] .btn-close {\n  filter: invert(1) grayscale(1) brightness(1.4);\n}\n\n/* ----- react-select (targets the classNamePrefix \"__\" convention used in\n   this app: react-select__, select__, failed-idoc-select__, etc.) ----- */\n[data-theme=\"dark\"] [class*=\"__control\"] {\n  background-color: var(--surface);\n  border-color: var(--border);\n  color: var(--text);\n}\n[data-theme=\"dark\"] [class*=\"__menu\"] {\n  background-color: var(--surface);\n  color: var(--text);\n  border: 1px solid var(--border);\n}\n[data-theme=\"dark\"] [class*=\"__option\"] {\n  background-color: var(--surface);\n  color: var(--text);\n}\n[data-theme=\"dark\"] [class*=\"__option\"]:hover,\n[data-theme=\"dark\"] [class*=\"__option--is-focused\"] {\n  background-color: var(--surface-hover) !important;\n  color: var(--text);\n}\n[data-theme=\"dark\"] [class*=\"__single-value\"],\n[data-theme=\"dark\"] [class*=\"__input\"],\n[data-theme=\"dark\"] [class*=\"__placeholder\"] {\n  color: var(--text);\n}\n[data-theme=\"dark\"] [class*=\"__multi-value\"] {\n  background-color: var(--surface-3);\n}\n[data-theme=\"dark\"] [class*=\"__multi-value__label\"] {\n  color: var(--text);\n}\n\n/* ----- react-datepicker ----- */\n[data-theme=\"dark\"] .react-datepicker {\n  background-color: var(--surface);\n  border-color: var(--border);\n  color: var(--text);\n}\n[data-theme=\"dark\"] .react-datepicker__header {\n  background-color: var(--surface-2);\n  border-color: var(--border);\n}\n[data-theme=\"dark\"] .react-datepicker__current-month,\n[data-theme=\"dark\"] .react-datepicker-time__header,\n[data-theme=\"dark\"] .react-datepicker__day-name,\n[data-theme=\"dark\"] .react-datepicker__day,\n[data-theme=\"dark\"] .react-datepicker__time-name {\n  color: var(--text);\n}\n[data-theme=\"dark\"] .react-datepicker__day:hover,\n[data-theme=\"dark\"] .react-datepicker__month-text:hover {\n  background-color: var(--surface-hover);\n}\n[data-theme=\"dark\"] .react-datepicker__day--selected,\n[data-theme=\"dark\"] .react-datepicker__day--keyboard-selected {\n  background-color: var(--primary);\n  color: #fff;\n}\n[data-theme=\"dark\"] .react-datepicker__time-container,\n[data-theme=\"dark\"] .react-datepicker__time,\n[data-theme=\"dark\"] .react-datepicker__time-box {\n  background-color: var(--surface);\n  color: var(--text);\n}\n[data-theme=\"dark\"] .react-datepicker__time-list-item:hover {\n  background-color: var(--surface-hover) !important;\n}\n\n/* ----- Scrollbars ----- */\n[data-theme=\"dark\"] ::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n}\n[data-theme=\"dark\"] ::-webkit-scrollbar-track {\n  background: var(--scrollbar-track);\n}\n[data-theme=\"dark\"] ::-webkit-scrollbar-thumb {\n  background: var(--scrollbar-thumb);\n  border-radius: 6px;\n}\n[data-theme=\"dark\"] * {\n  scrollbar-color: var(--scrollbar-thumb) transparent;\n}\n\n/* ----- Theme toggle button (navbar) ----- */\n.theme-toggle-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 42px;\n  padding: 0 14px;\n  border-radius: 10px;\n  border: 1px solid var(--border);\n  background: var(--surface-2);\n  color: var(--text-muted);\n  cursor: pointer;\n  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease, transform 0.12s ease;\n}\n.theme-toggle-label {\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1;\n}\n.theme-toggle-btn:hover {\n  background: var(--surface-hover);\n  border-color: var(--border-strong);\n  color: var(--text);\n}\n.theme-toggle-btn:active {\n  transform: scale(0.94);\n}\n.theme-toggle-btn:focus-visible {\n  outline: 2px solid var(--primary);\n  outline-offset: 2px;\n}\n\n@media (max-width: 768px) {\n  .theme-toggle-btn {\n    width: 40px;\n    height: 40px;\n    padding: 0;\n  }\n}\n\n/* ----- Tailwind utility classes (used across data/report/self-monitoring\n   pages). These have fixed light colors, so remap them in dark mode. ----- */\n[data-theme=\"dark\"] .bg-slate-50,\n[data-theme=\"dark\"] .bg-slate-100,\n[data-theme=\"dark\"] .bg-gray-50,\n[data-theme=\"dark\"] .bg-gray-100,\n[data-theme=\"dark\"] .bg-neutral-50,\n[data-theme=\"dark\"] .bg-neutral-100 {\n  background-color: var(--surface-2) !important;\n}\n\n[data-theme=\"dark\"] .bg-slate-200,\n[data-theme=\"dark\"] .bg-gray-200 {\n  background-color: var(--surface-3) !important;\n}\n\n/* Loading / dimming overlays that use white + opacity */\n[data-theme=\"dark\"] .bg-white.bg-opacity-75,\n[data-theme=\"dark\"] .bg-white.bg-opacity-80,\n[data-theme=\"dark\"] .bg-white.bg-opacity-90 {\n  background-color: rgba(15, 23, 42, 0.75) !important;\n}\n\n/* Text colors */\n[data-theme=\"dark\"] .text-black,\n[data-theme=\"dark\"] .text-slate-900,\n[data-theme=\"dark\"] .text-slate-800,\n[data-theme=\"dark\"] .text-slate-700,\n[data-theme=\"dark\"] .text-gray-900,\n[data-theme=\"dark\"] .text-gray-800,\n[data-theme=\"dark\"] .text-gray-700,\n[data-theme=\"dark\"] .text-neutral-800,\n[data-theme=\"dark\"] .text-neutral-700 {\n  color: var(--text) !important;\n}\n\n[data-theme=\"dark\"] .text-slate-600,\n[data-theme=\"dark\"] .text-slate-500,\n[data-theme=\"dark\"] .text-slate-400,\n[data-theme=\"dark\"] .text-gray-600,\n[data-theme=\"dark\"] .text-gray-500,\n[data-theme=\"dark\"] .text-gray-400,\n[data-theme=\"dark\"] .text-neutral-600,\n[data-theme=\"dark\"] .text-neutral-500 {\n  color: var(--text-muted) !important;\n}\n\n/* Borders */\n[data-theme=\"dark\"] .border-slate-100,\n[data-theme=\"dark\"] .border-slate-200,\n[data-theme=\"dark\"] .border-slate-300,\n[data-theme=\"dark\"] .border-gray-100,\n[data-theme=\"dark\"] .border-gray-200,\n[data-theme=\"dark\"] .border-gray-300,\n[data-theme=\"dark\"] .border-neutral-200,\n[data-theme=\"dark\"] .border-neutral-300 {\n  border-color: var(--border) !important;\n}\n\n/* Divide utilities (borders between children) */\n[data-theme=\"dark\"] .divide-slate-100 > :not([hidden]) ~ :not([hidden]),\n[data-theme=\"dark\"] .divide-slate-200 > :not([hidden]) ~ :not([hidden]),\n[data-theme=\"dark\"] .divide-gray-100 > :not([hidden]) ~ :not([hidden]),\n[data-theme=\"dark\"] .divide-gray-200 > :not([hidden]) ~ :not([hidden]) {\n  border-color: var(--border) !important;\n}\n\n/* Hover backgrounds (table rows, list items) */\n[data-theme=\"dark\"] .hover\\:bg-slate-50:hover,\n[data-theme=\"dark\"] .hover\\:bg-slate-100:hover,\n[data-theme=\"dark\"] .hover\\:bg-gray-50:hover,\n[data-theme=\"dark\"] .hover\\:bg-gray-100:hover {\n  background-color: var(--surface-hover) !important;\n}\n\n/* Soft accent tints used for badges / alerts */\n[data-theme=\"dark\"] .bg-red-50 {\n  background-color: rgba(239, 68, 68, 0.12) !important;\n}\n[data-theme=\"dark\"] .border-red-200 {\n  border-color: rgba(239, 68, 68, 0.35) !important;\n}\n[data-theme=\"dark\"] .text-red-800,\n[data-theme=\"dark\"] .text-red-700,\n[data-theme=\"dark\"] .text-red-600 {\n  color: #f87171 !important;\n}\n[data-theme=\"dark\"] .bg-blue-50,\n[data-theme=\"dark\"] .bg-indigo-50 {\n  background-color: rgba(59, 130, 246, 0.14) !important;\n}\n[data-theme=\"dark\"] .bg-green-50,\n[data-theme=\"dark\"] .bg-emerald-50 {\n  background-color: rgba(16, 185, 129, 0.14) !important;\n}\n[data-theme=\"dark\"] .bg-yellow-50,\n[data-theme=\"dark\"] .bg-amber-50 {\n  background-color: rgba(245, 158, 11, 0.14) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
